import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageview, initGA } from "../utils/analytics";

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA on mount
    initGA();
  }, []);

  useEffect(() => {
    // Track page views on route change
    const url = location.pathname + location.search;
    pageview(url);
  }, [location]);
};
